<template>
  <div style="display: inline-block;line-height: 18px;height: 18px;">
    <el-badge
        v-if="!status"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{'num':type==='num'}"
    >
      <slot></slot>
    </el-badge>
    <template v-else>
      <div class="gj-status-badge">
        <span class="dot" :style="{'background-color': colorMap}"></span><span><slot></slot></span>
      </div>
    </template>
  </div>
</template>

<script>
  import {isType} from '@/utils/common.js'
  export default {
    name: "gj-badge",
    props: {
      type: {
        type: String,
        default: null
      },
      status: {
        type: Boolean,
        default: false,
      },
      color: {
        type: String | Object,
        default: '#f56c6c'
      }
    },
    computed: {
      colorMap() {
        let color;
        if (isType(this.color, 'Object')) {
          color = this.color.color
        } else {
          color = this.color
        }
        return color
      }
    }
  }
</script>

<style scoped>
  .gj-status-badge {
    display: inline-flex;
    align-items: center;
  }
  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
  }
</style>
